export const ENV = new Proxy(
  { ...import.meta.env },
  {
    get(envVars, name) {
      if (name in envVars) {
        return envVars[name as keyof typeof envVars] as unknown;
      } else {
        const error = new Error(`Variable ${String(name)} is not defined in this environment`);

        console.error(error);
        throw error;
      }
    },
  }
);

(window as typeof window & { ENV: typeof ENV }).ENV = import.meta.env;
